import { ReactElement } from 'react';
import * as React from 'react';

import 'react-datepicker/dist/react-datepicker.min.css';

import { NextImage, Typography } from '@/shared/components/atoms';
import { IEmptyCardProps } from '@/shared/components/molecules/EmptyCard/IEmptyCard';
import { clsxm } from '@/shared/lib';

export default function EmptyCard({
  vector,
  variant,
  message,
  directiveMessage,
  classeName,
  footer,
  fullSVG,
}: IEmptyCardProps): ReactElement {
  const wrapperClasses = clsxm(
    ' flex flex-col w-full h-full items-center justify-center ',
    classeName
  );

  return (
    <div className={wrapperClasses}>
      {variant === 'circleIcon' || variant === 'icon' ? (
        <>
          {variant === 'circleIcon' ? (
            <span className='rounded-full bg-primary-100 p-32'>{vector}</span>
          ) : (
            <div className={`fullSVG ${fullSVG ? 'h-260 w-260' : 'h-72 w-72'}`}>
              {vector}
            </div>
          )}
          <Typography variant='body1' className='mb-2 mt-24' weight='bold'>
            {message}
          </Typography>
          <Typography variant='body2' className='text-text-600' weight='medium'>
            {directiveMessage}
          </Typography>
        </>
      ) : (
        <>
          {variant === 'image' && (
            <NextImage
              fill
              className='h-290 w-290'
              src={vector}
              alt={message}
            />
          )}

          <Typography
            variant='h2'
            weight='bold'
            className='mb-2 mt-24 text-primary-default'
          >
            {message}
          </Typography>
          <Typography variant='body1' className='text-text-600'>
            {directiveMessage}
          </Typography>
        </>
      )}
      <div>{footer}</div>
    </div>
  );
}
